import React, {useState, ReactElement, useRef} from 'react';
import {IconButton} from '@mui/material';
import './UserProfile.scss';
import {ReactComponent as CaretUp} from '../../../../assets/images/caret-up.svg';
import {ReactComponent as CaretDown} from '../../../../assets/images/caret-down.svg';
import ArrMenu, {ArrMenuHandle} from '../../../common/arr-menu/ArrMenu';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import ArrAvatar from '../../../common/arr-avatar/ArrAvatar';

interface User {
  userName: string;
  role: string;
}

interface IUserProfileMenuItem {
  id: string;
  label: string | ReactElement;
  onClick?: () => void;
}

interface UserProfileProps {
  user: User;
  menuItems: IUserProfileMenuItem[];
}

export type users = {
  children?: ReactElement | ReactElement[];
};

const UserProfile: React.FC<UserProfileProps> = ({menuItems}) => {
  const menuRef1 = useRef<ArrMenuHandle | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const loginUserData = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setIsMenuOpen(!isMenuOpen);
    menuRef1.current?.open(e.currentTarget as HTMLElement);
  };

  const handleMenuItemClick = (item: IUserProfileMenuItem) => {
    item?.onClick?.();
    setIsMenuOpen(false);
    buttonRef.current?.focus();
  };

  return (
    <div className="user-profile" data-testid={`user-profile-div`}>
      <IconButton
        ref={buttonRef}
        onClick={handleClick}
        className="user-profile-menu-icon-btn"
        size="large"
        aria-controls={isMenuOpen ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        aria-label="user-profile-button"
        data-testid="user-profile-button"
      >
        <ArrAvatar
          name={loginUserData?.userName || ''}
          className="user-profile-avatar"
          dataTestId="user-profile-avatar"
        />

        <div className="caret-icon" data-testid={`user-profile-div-btn`}>
          {isMenuOpen ? <CaretUp /> : <CaretDown />}
        </div>
      </IconButton>
      <ArrMenu
        id="arr-menu-1"
        ref={menuRef1}
        items={menuItems}
        title={`${loginUserData?.userName}`}
        direction="bottom-left"
        className="arr-user-profile-menu"
        autoFocusMenu
        disableAutoFocusItem={false}
        focusFirstMenuItemOnOpen
        onClose={() => {
         setTimeout(() => {
            buttonRef.current?.focus();
          }, 0)
         setIsMenuOpen(false)}}
        onItemClick={(item) => handleMenuItemClick(item)}
      />
    </div>
  );
};

export default UserProfile;
